import {CartAddEntryEvent, CartEvent, CartRemoveEntrySuccessEvent} from '@spartacus/cart/base/root';
import {LoginEvent} from '@spartacus/core';
import {OrderPlacedEvent} from '@spartacus/order/root';
import {NavigationEvent, PageEvent, ProductDetailsPageEvent, SearchPageResultsEvent} from '@spartacus/storefront';
import {DCPErrorMessageDisplayEvent, DCPErrorPageDisplayEvent} from '@dcp/configurator';
import {TmsCollectorConfig, TmsConfig} from '@spartacus/tracking/tms/core';
import {DCPErrorEvent} from '@app/core/components/error/dcp-error-events';
import {DtrumCollectorService} from '../services/dtrum-collector.service';

export interface DrumCollectorConfig extends TmsCollectorConfig {
  enabled?: boolean;
  scriptUrl?: string;
  autoInjectedCode?: boolean;
}

declare module '@spartacus/tracking/tms/core' {
  interface TmsCollectors {
    dtrum?: DrumCollectorConfig;
  }
}

export const defaultDtrumConfig: TmsConfig = {
  tagManager: {
    dtrum: {
      collector: DtrumCollectorService,
      events: [
        NavigationEvent,
        CartRemoveEntrySuccessEvent,
        CartEvent,
        CartAddEntryEvent,
        LoginEvent,
        ProductDetailsPageEvent,
        SearchPageResultsEvent,
        PageEvent,
        OrderPlacedEvent,
        DCPErrorEvent,
        DCPErrorMessageDisplayEvent,
        DCPErrorPageDisplayEvent,
      ],
    },
  },
};
